import { connect } from "react-redux";

import { Link } from "react-router-dom";

var StudentsSelectedDisplay = require("components/org/roster/StudentsSelectedDisplay");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var CurrentUser = require("lib/account/CurrentUser");

var HelpSectionLink = require("components/utility/HelpSectionLink");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ValidatingInput = require("components/utility/ValidatingInput");

var WhooosReadingServices = require("lib/web/WhooosReadingServices")
var DocumentClient = require("lib/web/DocumentClient");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

@connect(
	(state, props) => ({
		totalStudents: RosterSelectors.students({ state }).length,
		students: props.students.length ? props.students : RosterSelectors.students({ state })
	}),
	(dispatch, props) => ({
		updateStudent: (studentID, update) => {
			return dispatch(RosterActions.updateStudent({
				id: studentID, update, embeds: ["student.password"]
			}));
		},
		setParentLogins: () => {

		}
	})
)
class StudentLogins extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			editingStudent: null, overrideLoginData: {},
			errorMessages: {}, discardEdits: false
		};
	}

	openEdit(student) {
		if (!this.validateFields()) { return; }
		this.submitEditedInformation();
		this.setState({ editingStudent: student });
	}

	closeEdit(e) {
		$wr.nope(e)
		if (!this.validateFields()) { return; }
		this.submitEditedInformation();
		this.setState({ editingStudent: null });
	}

	onKeyPress(event) {
		if (event.keyCode == 13) {
			this.closeEdit(event);
		}
	}

	setErrors(studentID, errorArray) {
		var errorData = _.clone(this.state.errorMessages);
		var usernameErrors = _.filter(errorArray, function (error) {
			return error.includes("sername");
		});
		var passwordErrors = _.filter(errorArray, function (error) {
			return error.includes("assword");
		});
		errorData[studentID] = {};
		errorData[studentID].usernameErrors = usernameErrors;
		errorData[studentID].passwordErrors = passwordErrors;

		this.setState({ errorMessages: errorData });
	}

	updateOverrideData(studentID, attribute, event) {
		var overrideData = _.clone(this.state.overrideLoginData);
		overrideData[studentID] = _.clone(overrideData[studentID] || {});
		overrideData[studentID][attribute] = event.target.value.trim();
		this.setState({ overrideLoginData: overrideData });
	}

	clearOverridesAndErrors(studentID) {
		var newOverrideData = _.omit(this.state.overrideLoginData, studentID);
		var newErrorData = _.omit(this.state.errorMessages, studentID);
		this.setState({ overrideLoginData: newOverrideData, errorMessages: newErrorData });
	}

	submitEditedInformation() {
		if (!this.validateFields()) { return; }

		var previousStudent = this.state.editingStudent;

		if (previousStudent) {
			var studentData = this.state.overrideLoginData[previousStudent.id];

			if (studentData && (studentData.username || studentData.password_plain_text)) {
				var params = { student: studentData, embed: "student.password,student.student_list" };
				var text = "You have edited the login information of " + previousStudent.display_name + "."

				this.props.updateStudent(previousStudent.id, studentData).then((response) => {
					var studentResponse = response.students[0];
					if (!studentResponse.errors) {
						this.clearOverridesAndErrors(previousStudent.id);

						window.wrNotifications.triggerDropDownNotification({
							title: "Information Edited!", text: text,
							icon: "ok-circle"
						})
					} else {
						this.setErrors(previousStudent.id, studentResponse.errors);
					}
				})
			}
		}
	}

	validateFields() {
		var isValid = true;
		if (this.refs["usernameInput"]) {
			isValid = isValid & this.refs["usernameInput"].validate();
		}
		if (this.refs["passwordInput"]) {
			isValid = isValid & this.refs["passwordInput"].validate();
		}
		return isValid;
	}

	renderStudentRows() {
		var selectedStudents = _.clone(this.props.students);

		// unfortunate code to bring the demo student to the top of the list
		var demoStudents = _.filter(selectedStudents, (student) => {
			return student.demo_for_teacher;
		});
		var nonDemoStudents = _.reject(selectedStudents, (student) => {
			return student.demo_for_teacher;
		});
		var sortedNonDemoStudents = $wr.sortByName(nonDemoStudents, "flexName");
		var sortedStudents = _.union(demoStudents, sortedNonDemoStudents);

		return sortedStudents.map((student) => {
			var studentOverrideData = this.state.overrideLoginData[student.id];
			if (studentOverrideData) {
				var defaultUsername = studentOverrideData.username || student.username;
				var defaultPassword = studentOverrideData.password_plain_text || student.password;
			} else {
				var defaultUsername = student.username;
				var defaultPassword = student.password;
			}

			if (this.state.editingStudent == student) {
				var usernameContent = (
					<div className="username">
						<ValidatingInput ref="usernameInput" type="text" inputName="Username"
							defaultValue={defaultUsername} onKeyDown={this.onKeyPress}
							validators={ValidatingInput.Validators.PRESENT}
							onChange={this.updateOverrideData.bind(this, student.id, "username")}
							inputClassName="form-control usernameInput" />
					</div>
				);
				var passwordContent = (
					<div className="password">
						<ValidatingInput ref="passwordInput" type="text" inputName="Password"
							defaultValue={defaultPassword} onKeyDown={this.onKeyPress}
							validators={ValidatingInput.Validators.PRESENT}
							onChange={this.updateOverrideData.bind(this, student.id, "password_plain_text")}
							inputClassName="form-control passwordInput" />
						<div className="enterToSubmit">
							<a href="#" onClick={this.closeEdit}>Press enter</a> to submit
						</div>
					</div>
				);
			} else {
				if (defaultPassword) {
					var passwordDisplay = defaultPassword;
				} else {
					var passwordDisplay = (
						<em>set by student</em>
					);
				}

				var studentErrors = this.state.errorMessages[student.id];
				if (studentErrors && studentErrors.usernameErrors.length > 0) {
					var usernameIcon = (
						<Glyphicon icon="exclamation-sign" className="errorIcon"
							dataTip={studentErrors.usernameErrors.join(". ")} />
					);
				} else {
					var usernameIcon = (
						<Glyphicon icon="pencil" className="editIcon" />
					);
				}
				if (studentErrors && studentErrors.passwordErrors.length > 0) {
					var passwordIcon = (
						<Glyphicon icon="exclamation-sign" className="errorIcon"
							dataTip={studentErrors.passwordErrors.join(". ")} />
					);
				} else {
					var passwordIcon = (
						<Glyphicon icon="pencil" className="editIcon" />
					);
				}
				var usernameContent = (
					<div className="username editable"
						onClick={() => this.openEdit(student)}>
						<span className="clickableElement ellipsisText">{defaultUsername}</span> {usernameIcon}
					</div>
				);
				var passwordContent = (
					<div className="password editable"
						onClick={() => this.openEdit(student)}>
						<span className="clickableElement ellipsisText">{passwordDisplay}</span> {passwordIcon}
					</div>
				);
			}

			if (student.demo_for_teacher) {
				var demoIndicator = (<span className="demoIndicator">DEMO</span>);
			}

			return (
				<div key={student.id} className="studentRow">
					<div className="name">
						{student.display_name}
						{demoIndicator}
					</div>
					{usernameContent}
					{passwordContent}
				</div>
			);
		});
	}

	renderMainDisplay() {
		var students = this.props.students
		if (students && students.length > 0) {
			var studentIDs = _.pluck(this.props.students, "id");
			var viewAllPath = "/logins/cards?student_ids=" + studentIDs.join(",");

			var students = this.props.students;
			var studentsWithParents = [];
			students.map(function (student) {
				if (student.has_parent) {
					studentsWithParents.push(student.has_parent);
				}
				studentIDs.push(student.id)
			})
			if (studentsWithParents.length > 0) {
				var sendParentEmailLink = (
					<a onClick={this.sendParentEmail}>
						Send Parent Email
					</a>
				)
			}

			var addParentEmailsLink = (
				<Link to="/student_parents">
					Add Parent Emails
				</Link>
			)

			return (
				<div>
					<div>
						<div className="printSection">
							<a href="#" onClick={DocumentClient.buildOpenF(viewAllPath)}>
								Print login cards
							</a>
							<br />
							<span className="smallText">Enable pop-ups to open</span>
							<HelpSectionLink featureName="allowing pop-ups" linkSuffix="115002455792" iconOnly={true} />
						</div>
						<div className="sendParentEmailSection">
							{sendParentEmailLink}
							{addParentEmailsLink}
						</div>
					</div>

					<div>
						<div className="headerRow">
							<div className="name">Name</div>
							<div className="username">
								Username
								<span className="editHelperText">Click to edit</span>
							</div>
							<div className="password">
								Password
								<span className="editHelperText">Click to edit</span>
							</div>
						</div>
						{this.renderStudentRows()}
					</div>
				</div>
			);

		} else {
			return (
				<div>
					<p>
						<a href="#" onClick={DocumentClient.buildOpenF("/logins/cards")}>
							Print all of your students' usernames and passwords.
						</a>
					</p>
					<p>Select students on your roster to see individual login information.</p>
				</div>
			);
		}
	}

	render() {
		return (
			<div className="studentLogins">
				{this.renderMainDisplay()}
			</div>
		)
	}
};

StudentLogins.WrappedComponent.propTypes = StrictPropTypes({
	// From above
	students: PropTypes.array,

	// Data from @connect
	totalStudents: PropTypes.number,

	// Handler from @connect
	updateStudent: PropTypes.func,
	setParentLogins: PropTypes.func
});

module.exports = StudentLogins;



// WEBPACK FOOTER //
// ./modules/components/org/roster/StudentLogins.js